/* Kidney Support Powder for Cats on the oc-ph-hw-v1 page layout. The packs are the current Kidney page's: 1, 2 or 3 tubs
   of the one variant, one-time only (the product has no selling plans). The store's automatic discounts "Kidney Support
   Powder 2-pack savings" (28.56% at 2+) and "3-pack savings" (33.33% at 3+) price them; Shopify takes floor(price x
   rate) off each tub, which matched real carts to the cent on 28 Oct 2026 (A$55.00 / A$78.60 / A$110.01). A pack goes
   in as one plain line with the same property as the old page (_oc_range_page), so repeat adds merge in the cart. */
(() => {
  'use strict';
  const root = document.querySelector('[data-oc-hw-native]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-hw-config]').textContent);
  const decoder = document.createElement('textarea');
  Object.keys(cfg.strings).forEach(key => {decoder.innerHTML=cfg.strings[key];cfg.strings[key]=decoder.value;});
  const params = new URLSearchParams(location.search);
  const form = root.querySelector('[data-hw-purchase]');
  const button = form.querySelector('[data-hw-add]');
  const label = button.querySelector('[data-hw-add-label]');
  const offerRoot = root.querySelector('[data-hw-offers]');
  const status = root.querySelector('[data-hw-status]');
  const radios = [...root.querySelectorAll('[name="oc-hw-pack"]')];
  let busy = false, uncertain = false;

  const formatter = new Intl.NumberFormat('en-US', {style:'currency',currency:cfg.currency});
  const money = cents => formatter.format(cents / 100);
  const price = cfg.variant.price;
  // The tier the whole cart's Kidney quantity reaches, and the price of one tub at that tier.
  const rateFor = tubs => tubs >= 3 ? Number(cfg.discounts['3']) : tubs >= 2 ? Number(cfg.discounts['2']) : 0;
  const unitFor = tubs => price - Math.floor(price * rateFor(tubs) + 1e-7);
  const packTotal = tubs => tubs * unitFor(tubs);
  root.querySelectorAll('.product-info .review-product-title + .product-price').forEach(value => {value.textContent = money(price);});
  const endpoint = suffix => cfg.root.replace(/\/$/,'') + '/cart/' + suffix;
  const cartEndpoint = cfg.root.replace(/\/$/,'') + '/cart.js';
  const selected = () => Number(radios.find(r => r.checked)?.value) || 0;
  const announce = message => { status.textContent = message; };
  const cartCount = cart => document.querySelectorAll('[data-hw-cart-count]').forEach(n => {const value=String(cart.item_count);if(n.textContent!==value)n.textContent=value;});
  // The store-wide cart drawer (snippets/oc-cart, rendered by this layout) opens with a cart we already read.
  const openCart = cart => {
    if (window.ocCart) return window.ocCart.open(cart);
    location.assign(cfg.root.replace(/\/$/,'') + '/cart');
  };
  const loadCart = async () => {
    const response = await fetch(cartEndpoint, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error(cfg.strings.cartCheck);
    return response.json();
  };
  const post = async (path,body) => {
    const response = await fetch(endpoint(path), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || cfg.strings.error);
    return data;
  };
  function marketUrl() {
    const url = new URL(location.href);
    url.searchParams.set('view',cfg.view);
    url.searchParams.delete('country');
    return url.pathname + url.search;
  }
  const marketForm = document.getElementById('oc-hw-market');
  const mobileMenu = document.querySelector('.oc-hw-mobile-nav');
  const mobileMarket = document.querySelector('[data-hw-mobile-market]');
  const desktopMarket = document.querySelector('[data-hw-desktop-market]');
  const mobileHeader = matchMedia('(max-width: 989px)');
  const placeMarket = () => {
    const destination = mobileHeader.matches ? mobileMarket : desktopMarket;
    if (marketForm && destination && marketForm.parentElement !== destination) destination.append(marketForm);
    if (!mobileHeader.matches && mobileMenu) mobileMenu.open = false;
  };
  placeMarket();
  mobileHeader.addEventListener('change',placeMarket);
  mobileMenu?.addEventListener('keydown',event => {
    if (event.key === 'Escape' && mobileMenu.open) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary').focus();
    }
  });
  const countrySelect = marketForm?.querySelector('[data-hw-country]');
  countrySelect?.addEventListener('change', () => {
    marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
    marketForm.submit();
  });
  if (cfg.requiredCountry && cfg.country !== cfg.requiredCountry && !window.Shopify?.designMode) {
    button.disabled = true;
    if (countrySelect && [...countrySelect.options].some(o => o.value === cfg.requiredCountry)) {
      countrySelect.value = cfg.requiredCountry;
      marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
      marketForm.submit();
    } else announce('This country is not available in the store.');
    return;
  }
  const plural = n => `${n} tub${n === 1 ? '' : 's'}`;
  function render() {
    const ready = Number.isFinite(price) && price > 0;
    radios.forEach(radio => {
      const tubs = Number(radio.value);
      const node = radio.closest('[data-oc-bottles]');
      node.classList.toggle('kaching-bundles__bar--selected',radio.checked);
      radio.disabled = !ready || !cfg.variant.available || busy || uncertain;
      if (!ready) return;
      const amount = packTotal(tubs), each = amount / tubs;
      // "Save" is against buying the same tubs one at a time, as on the current page.
      const save = Math.round((1 - amount / (price * tubs)) * 100);
      const saveNode = node.querySelector('[data-hw-save]');
      saveNode.textContent = save > 0 ? `Save ${save}%` : '';
      saveNode.style.display = save > 0 ? '' : 'none';
      const eachNode = node.querySelector('[data-hw-each]');
      eachNode.replaceChildren(document.createTextNode(money(each)+' '));
      const per = document.createElement('span');per.className='kaching-bundles__bar-price__unit-label';per.textContent='per tub';eachNode.append(per);
      eachNode.setAttribute('aria-label',money(each)+' per tub');
      const reference = node.querySelector('[data-hw-reference]');
      reference.textContent = save > 0 ? money(price) : '';
      reference.hidden = !(save > 0);
      const total = node.querySelector('[data-hw-total]');if(total)total.textContent=`${plural(tubs)}, total: ${money(amount)}`;
    });
    const tubs = selected();
    form.querySelector('[data-hw-variant]').value = String(cfg.variant.id);
    form.querySelector('[name="quantity"]').value = String(tubs || 1);
    const renewal = root.querySelector('[data-hw-renewal]');
    if (ready && tubs) renewal.textContent = `One-time purchase: ${money(packTotal(tubs))} for ${plural(tubs)} (${tubs * cfg.servingsPerTub} servings). No recurring charges. Follow the label for your cat's daily amount. Prices in ${cfg.currency}.`;
    button.disabled = busy || uncertain || !ready || !cfg.variant.available || !tubs;
    label.textContent = busy ? cfg.strings.adding : !cfg.variant.available ? cfg.strings.unavailable : cfg.strings.add;
    offerRoot.style.visibility = 'visible';
    root.dataset.hwReady = String(!button.disabled);
  }
  radios.forEach(r => r.addEventListener('change',render));
  function lineProperties() {
    const properties = {_oc_range_page:cfg.handle,_oc_kidney_page:cfg.pageVersion,_oc_market:cfg.country};
    for (const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']) {const value=params.get(key);if(value)properties['_'+key]=value.slice(0,150);}
    if (params.get('oc_qa')==='1') properties._oc_qa = cfg.pageVersion;
    return properties;
  }
  form.addEventListener('submit',async event => {
    event.preventDefault();if(button.disabled||busy||uncertain)return;
    busy=true;announce('');render();
    const tubs=selected(),properties=lineProperties();
    const items=[{id:cfg.variant.id,quantity:tubs,properties}];
    if(params.get('oc_qa')==='1')root.dataset.hwSubmitItems=JSON.stringify(items);
    let submitted=false,added=false,before=0;
    const isKidney=line=>line.variant_id===cfg.variant.id&&!line.selling_plan_allocation;
    const ours=line=>isKidney(line)&&line.properties?._oc_kidney_page===cfg.pageVersion&&line.properties?._oc_range_page===cfg.handle;
    const qtyOf=(cart,test)=>cart.items.filter(test).reduce((sum,line)=>sum+line.quantity,0);
    try{
      const baseline=await loadCart();
      if(baseline.currency!==cfg.currency)throw new Error('Your currency changed. Refresh the page before adding this pack.');
      before=qtyOf(baseline,ours);
      submitted=true;
      await post('add.js',{items});
      added=true;
      const cart=await loadCart();
      // Every Kidney line in the cart is priced at the tier the cart's whole Kidney quantity reaches (1 cent a tub of
      // rounding allowed). A pack that would cost more than the page showed is taken back out.
      const all=qtyOf(cart,isKidney),lines=cart.items.filter(isKidney);
      const paid=lines.reduce((sum,line)=>sum+line.final_line_price,0);
      const ok=cart.currency===cfg.currency&&qtyOf(cart,ours)===before+tubs&&lines.every(line=>line.original_price===price)
        &&paid<=all*unitFor(all)+all;
      if(!ok){
        const line=cart.items.find(ours);
        const restored=line?await post('change.js',{id:line.key,quantity:line.quantity-tubs}):cart;
        if(qtyOf(restored,ours)!==before)throw new Error(cfg.strings.cartCheck);
        cartCount(restored);added=false;submitted=false;
        throw new Error('This pack could not be priced correctly, so nothing was added. Please refresh and try again.');
      }
      cartCount(cart);openCart(cart);announce(cfg.strings.added);
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())window.dataLayer?.push({event:'oc_kidney_add_to_cart',page:cfg.pageVersion,tubs,currency:cfg.currency,qa:params.get('oc_qa')==='1'});
    }catch(error){
      // A timeout can come after Shopify accepted the items. Check the saved cart before allowing another
      // click, so a retry cannot double an order.
      if(submitted){
        try{const cart=await loadCart();const now=qtyOf(cart,ours);added=added||now>before;cartCount(cart);uncertain=now!==before&&now!==before+tubs;}
        catch{uncertain=true;}
      }
      announce(uncertain?cfg.strings.cartCheck:error instanceof TypeError?cfg.strings.error:error.message||cfg.strings.error);
      if(uncertain||added){const link=document.createElement('a');link.href=cfg.root.replace(/\/$/,'')+'/cart';link.textContent=' View cart';status.append(link);}
    }finally{busy=false;render();}
  });
  document.querySelectorAll('[data-hw-cart]').forEach(button=>button.addEventListener('click',()=>openCart()));
  window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
  const loadImage=img=>{if(img?.dataset.src){img.src=img.dataset.src;if(img.dataset.srcset)img.srcset=img.dataset.srcset;delete img.dataset.src;delete img.dataset.srcset;}};
  const formula=root.querySelector('#oc-hw-formula'),feeding=root.querySelector('#oc-hw-feeding'),zoom=root.querySelector('#oc-hw-zoom');
  // Safari before iOS 15.4 has no <dialog>: hide these three pop-ups until opened and open/close them by hand there.
  [formula,feeding,zoom].forEach(d=>{if(!d||typeof d.showModal==='function')return;if(!document.getElementById('oc-dialog-fallback')){const st=document.createElement('style');st.id='oc-dialog-fallback';st.textContent='#oc-hw-formula:not([open]),#oc-hw-feeding:not([open]),#oc-hw-zoom:not([open]){display:none}#oc-hw-formula[open],#oc-hw-feeding[open],#oc-hw-zoom[open]{position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2147483000;margin:0;max-height:88vh;overflow:auto;box-shadow:0 0 0 100vmax rgba(11,30,57,.7)}';document.head.appendChild(st);}d.showModal=()=>d.setAttribute('open','');d.close=()=>d.removeAttribute('open');});
  const formulaArtwork=root.querySelectorAll('.shop-main-image')[9]||root.querySelectorAll('.shop-main-image')[3];
  const showFormula=()=>{const img=formula.querySelector('[data-hw-formula-image]');img.src=formulaArtwork.dataset.zoomSrc||formulaArtwork.dataset.src||formulaArtwork.src;img.alt=formulaArtwork.alt;};
  root.querySelectorAll('[data-hw-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=button.dataset.hwOpen==='formula'?formula:feeding;if(dialog===formula)showFormula();else dialog.querySelectorAll('img').forEach(loadImage);dialog.showModal();dialog.querySelector('[data-hw-close]').focus();}));
  [formula,feeding,zoom].forEach(dialog=>{dialog.querySelector('[data-hw-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});});
  root.querySelector('.shop-main-image-wrapper')?.addEventListener('click',e=>{if(e.target.closest('button,a'))return;const active=root.querySelector('.shop-main-image.active');if(!active)return;const img=zoom.querySelector('img');img.src=active.dataset.zoomSrc||active.src;img.alt=active.alt;zoom.showModal();});
  // Keep FAQ paragraphs intact and expose the existing accordion to keyboards.
  root.querySelectorAll('.faq-question').forEach(question=>{const item=question.closest('.faq-item');question.tabIndex=0;question.setAttribute('role','button');const syncExpanded=()=>{const expanded=String(item.classList.contains('active'));if(question.getAttribute('aria-expanded')!==expanded)question.setAttribute('aria-expanded',expanded);};const faqObserver=new MutationObserver(syncExpanded);faqObserver.observe(item,{attributes:true,attributeFilter:['class']});faqObserver.observe(question,{attributes:true,attributeFilter:['aria-expanded']});syncExpanded();question.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();question.click();}});});
  root.querySelectorAll('.shop-thumbnail').forEach((thumb,i)=>{thumb.tabIndex=0;thumb.setAttribute('role','button');thumb.setAttribute('aria-label',`View product image ${i+1}`);thumb.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();thumb.click();}});});
  const gallerySurface=root.querySelector('.shop-main-image-wrapper');
  if(gallerySurface){
    [-1,1].forEach(direction=>{
      const arrow=document.createElement('button');arrow.type='button';
      arrow.className='oc-hw-gallery-arrow '+(direction<0?'prev':'next');
      arrow.setAttribute('aria-label',direction<0?'Previous product image':'Next product image');
      arrow.textContent=direction<0?'‹':'›';
      arrow.addEventListener('click',()=>{
        const dots=[...root.querySelectorAll('.shop-dot')];
        const index=[...root.querySelectorAll('.shop-main-image')].findIndex(img=>img.classList.contains('active'));
        dots[(index+direction+dots.length)%dots.length]?.click();
      });
      gallerySurface.append(arrow);
    });
  }
  render();
})();
